module.exports = __webpack_public_path__ + "img/ticket_count.dd136db4.svg";